import { Box, Card, Grid, IconButton, Tooltip } from "@mui/material";
import GenericModal from "components/GenericModal";
import MDTypography from "components/MDTypography";
import { Close, Download } from "@mui/icons-material";
import React, { useEffect, useState } from "react";
import ResumeContent from "layouts/pages/applicants/components/ApplicantResume/ResumeContent";
import { formatResumeData } from "utils/resumeFormatter";
import { useAppContextController } from "context/AppContext";
import { getCompanyBaseImageUrl } from "utils/helpers/upload";
import { fetchAndConvertToBase64 } from "utils/imageUtils";
import { ResumeDownloadButton } from "./components/ResumePDF";

const ResumeSummaryModal = ({ open, setOpen, currentApplicant }) => {
  const { company, isMobile } = useAppContextController();
  const [companyLogoBase64, setCompanyLogoBase64] = useState("");
  const [logoLoading, setLogoLoading] = useState(false);
  const formattedResumeData = formatResumeData(currentApplicant);

  const logoSrc = getCompanyBaseImageUrl(company)
    ? `${getCompanyBaseImageUrl(company)}/square-logo/${company?.squareLogoUrl}`
    : "";

  useEffect(() => {
    if (logoSrc) {
      setLogoLoading(true);
      fetchAndConvertToBase64(logoSrc)
        .then((base64Data) => {
          setCompanyLogoBase64(base64Data);
          setLogoLoading(false);
        })
        .catch((error) => {
          console.error("Error loading or converting logo to base64:", error);
          setCompanyLogoBase64("");
          setLogoLoading(false);
        });
    } else {
      setCompanyLogoBase64("");
      setLogoLoading(false);
    }
  }, [logoSrc]);

  const isDownloadReady = !logoLoading && (companyLogoBase64 || !logoSrc);

  const header = (
    <Grid container flexDirection="row" justifyContent="space-between" alignItems="center">
      <MDTypography
        variant="h5"
        color="dark"
        sx={{ mt: 2, mb: 1, ml: 2 }}
        key={`text_addNote_${currentApplicant?._id}`}
      >
        Resume For {currentApplicant?.firstName} {currentApplicant?.lastName}
      </MDTypography>
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, mr: 1 }}>
        {formattedResumeData && (
          <Tooltip title={logoLoading ? "Preparing logo..." : "Download Resume PDF"}>
            <span>
              <ResumeDownloadButton
                resumeData={formattedResumeData}
                buttonText={
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <Download fontSize="small" />
                    {!isMobile && (logoLoading ? "Preparing..." : "Download PDF")}
                  </Box>
                }
                companyName={company?.name}
                companyLogo={companyLogoBase64}
                disabled={!isDownloadReady}
              />
            </span>
          </Tooltip>
        )}
        <IconButton
          onClick={(e) => {
            e.stopPropagation();
            setOpen(false);
          }}
        >
          <Close fontSize="medium" color="dark" />
        </IconButton>
      </Box>
    </Grid>
  );

  const modalBody = formattedResumeData ? (
    <ResumeContent resumeData={formattedResumeData} height="80vh" />
  ) : (
    <Card>
      <MDTypography variant="body2" color="text">
        No resume data available
      </MDTypography>
    </Card>
  );

  return (
    <>
      <GenericModal
        open={open}
        setOpen={setOpen}
        body={modalBody}
        header={header}
        sx={(theme) => ({
          width: "70% !important",
          height: "95%",
          overflow: "hidden !important",
          [theme.breakpoints.down("md")]: {
            "& .MuiCardContent-root": {
              padding: "0px",
            },
          },
        })}
      />
    </>
  );
};

export default ResumeSummaryModal;
